import { useEffect, useState } from "react";

import {
    MenuPhotosDto,
    MenuSettingsDto,
    ThemeSettingsDto,
} from "services/menu/restModels";

const EMPTY_PHOTOS: MenuPhotosDto = {
    logoPhotoUrl: null,
    backgroundPhotoUrl: null,
};

const DEFAULT_THEME: ThemeSettingsDto = {
    themeId: "default",
    storefrontPhotosMode: "defaultWithPhotos",
    buttonsBackgroundColor: null,
    categoriesBackgroundColor: null,
    oldPriceLabel: null,
};

export const useAppearanceState = (settings: MenuSettingsDto | null) => {
    const [photos, setPhotos] = useState<MenuPhotosDto>(EMPTY_PHOTOS);
    const [theme, setTheme] = useState<ThemeSettingsDto>(DEFAULT_THEME);

    useEffect(() => {
        if (!settings) return;

        setPhotos({
            logoPhotoUrl: settings.photos.logoPhotoUrl,
            backgroundPhotoUrl: settings.photos.backgroundPhotoUrl,
        });
        /*
        * Раскладываем по полям, а не кладём объект ответа целиком: этот же объект уезжает
        * обратно в PUT, и любое лишнее поле (например, снятый с контракта
        * categoryListPhotosMode из кеша старого ответа) свалит десериализацию на бэке.
        * */
        setTheme({
            themeId: settings.themeSettings.themeId,
            storefrontPhotosMode: settings.themeSettings.storefrontPhotosMode,
            buttonsBackgroundColor: settings.themeSettings.buttonsBackgroundColor,
            categoriesBackgroundColor: settings.themeSettings.categoriesBackgroundColor,
            oldPriceLabel: settings.themeSettings.oldPriceLabel,
        });
    }, [settings]);

    const setBackgroundPhotoUrl = (backgroundPhotoUrl: string) =>
        setPhotos((prev) => ({ ...prev, backgroundPhotoUrl }));

    const setLogoPhotoUrl = (logoPhotoUrl: string) =>
        setPhotos((prev) => ({ ...prev, logoPhotoUrl }));

    const setThemeField = <K extends keyof ThemeSettingsDto>(
        field: K,
        value: ThemeSettingsDto[K]
    ) => setTheme((prev) => ({ ...prev, [field]: value }));

    const setLocalizedOldPriceLabel = (value: string, lang: string) =>
        setTheme((prev) => ({
            ...prev,
            oldPriceLabel: { ...(prev.oldPriceLabel || {}), [lang]: value },
        }));

    return {
        photos,
        theme,
        setBackgroundPhotoUrl,
        setLogoPhotoUrl,
        setThemeField,
        setLocalizedOldPriceLabel,
    };
};

export type AppearanceState = ReturnType<typeof useAppearanceState>;
